import { render } from "./coursesListFilters.component.vue?vue&type=template&id=6537d02f&ts=true"
import script from "./coursesListFilters.component.vue?vue&type=script&lang=ts"
export * from "./coursesListFilters.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__